import React from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import { Link } from 'react-router-dom';

const VideoSection = () => {
  return (
    <section className="pt-24 pb-16 bg-slate-50 text-slate-900 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 text-center">
          <h2 className="text-3xl md:text-4xl font-medium mb-6 uppercase">Se stemningen fra Spanien</h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Oplev golfbanerne, lejlighederne og det fantastiske fællesskab, der venter dig på Costa de la Luz.
          </p>
        </div>

        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="relative aspect-[21/9] rounded-3xl overflow-hidden shadow-2xl group"
        >
          <video 
            src="/video/5058601-uhd_3840_2160_25fpdds.mp4" 
            className="w-full h-full object-cover brightness-90 group-hover:scale-105 transition-transform duration-700"
            autoPlay
            muted
            loop
            playsInline
          />
        </motion.div>

        <div className="mt-10 text-center">
          <h3 className="text-2xl font-medium mb-6 uppercase">Vil du med næste gang?</h3>
          <Link 
            to="/kontakt" 
            className="inline-flex items-center justify-center px-10 py-4 rounded-full bg-[#39d14b] text-white font-medium text-lg hover:-translate-y-1 transition-all shadow-lg shadow-[#39d14b]/20 uppercase tracking-wider"
          >
            Book dit ophold nu
          </Link>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
